export interface Links {
  githubLink: string;
  linkedinLink: string;
  linkGit1: string;
  linkGit2: string;
  linkGit3: string;
  linkGit4: string;
  linkGit5: string;
}

export const usefulLinks: Links = {
  githubLink: "https://github.com/felipeFrancca",
  linkedinLink: "https://www.linkedin.com/in/felipe-françaa/",
  linkGit1: "https://github.com/FelipeFrancca/dieta-facil",
  linkGit2: "https://github.com/FelipeFrancca/salesFlow",
  linkGit3: "https://github.com/FelipeFrancca/listOfCharacters",
  linkGit4: "https://github.com/FelipeFrancca/fakeTrello",
  linkGit5: "https://github.com/FelipeFrancca/loginpage",
};
